// extracted by mini-css-extract-plugin
module.exports = {"ouc7b0z":"ouc7b0z","w1yl3sn1":"w1yl3sn1","k19c6k44":"k19c6k44","kodwvhk":"kodwvhk"};